<div class="modal-header bg-white">
  <h5 class="modal-title" id="staticBackdropLabel" *ngIf="entity" i18n="@@EditDeliveryNoteHeader">
    Lieferschein {{ entity.deliveryNoteNumber }}
  </h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <p class="alert alert-warning" *ngIf="!isValid">
    <app-svg source="icons/feather/alert-triangle"
      height="18px"
      style="position: relative; top: -2px;"></app-svg>
    {{ validationIssue }}
  </p>

  <form [formGroup]="form" *ngIf="formCreated">
    <label for="deliveryNoteNumber" i18n="@@DeliveryNoteNumberLabel">Name des Lieferscheins:</label>
    <div class="input-group">
      <input type="text" id="firstName" formControlName="deliveryNoteNumber" class="form-control" placeholder="Name des Lieferscheins"  i18n-placeholder="@@NameOfDeliveryNotes"/>
      <button type="button" id="change_name" class="btn btn-yellow" (click)="changeDeliveryNoteName()" i18n="@@ChangeName" *ngIf="(config?.isSendButtonVisible && permissions?.evaluationDeliveryNotesSend) || this.isOperatorView">Name ändern</button>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button"
          id="delete_deliverynote"
          class="btn btn-danger"
          data-bs-dismiss="modal"
          (click)="openDeleteDialog()"
          i18n="@@DeliveryNoteDeleteButton"
          *ngIf="(config?.isSendButtonVisible && permissions?.evaluationDeliveryNotesSend) || this.isOperatorView">

    <span class="d-md-inline ps-1">Lieferschein löschen</span>
  </button>

  <button class="btn btn-yellow"
          id="send_pdf"
          ngbTooltip="E-Mail mit PDF-Dokument im Anhang verschicken"
          i18n-ngbTooltip="@@SendPdfAsEmail"
          i18n="@@DeliveryNoteSendButton"
          *ngIf="(config?.isSendButtonVisible && permissions?.evaluationDeliveryNotesSend) ||this.isOperatorView"
          (click)="openSendPdfEmail()">
    <app-svg source="icons/feather/send" height="18"></app-svg>

  </button>

  <button class="btn btn-yellow ms-1"
          id="download_pdf"
          i18n-ngbTooltip="@@SendPDFAsEmail"
          i18n="@@DeliveryNoteDownloadButton"
          (click)="downloadPdf()">
    <app-svg source="icons/feather/download" height="18"></app-svg>

  </button>

  <button class="btn btn-yellow ms-1"
          id="download_csv"
          ngbTooltip="Als CSV herunterladen"
          i18n="@@DeliveryNoteDownloadCSVButton"
          (click)="downloadCSV()">
    <app-svg source="icons/feather/save" height="18"></app-svg>

  </button>

  <div *ngIf="showEmail" style="width: 100%;">
    <div class="input-group">
      <input (input)="setIsEmailValid()" type="text" id="input_sendMail" class="form-control" placeholder="E-Mail-Adresse des Empfängers" i18n-placeholder="@@NameOfDeliveryNotes" />
      <button (click)="sendPdfEmail()" [disabled]="!isEmailValid" type="button" id="btn_sendMail" class="btn btn-yellow" i18n="@@ChangeName">senden</button>
    </div>
  </div>
</div>
